import type { ClientConfig } from "@/features/client-config/types/client-config";

import type { GlobalAnalyticsContext } from "./types";

export const buildGlobalAnalyticsContext = (
  clientConfig: ClientConfig | null
): GlobalAnalyticsContext => ({
  courseId: clientConfig?.courseIdentifier,
  courseName: clientConfig?.courseDisplayName ?? "",
  holeNumber: clientConfig?.holeNumber ?? 0,
  deviceId: clientConfig?.deviceId,
  country: clientConfig?.defaultCountry,
  consentRequiredModeEnabled: clientConfig?.consentEnabled ?? false,
});
